export enum SearchMainComponentEnum {
  SERP = 'serp',
  SERVICE = 'service',
  SYMPTOM = 'symptom',
}
